/*
 * WOW Search - our own search dropdown and search results page, run side by
 * side with Rebuy's Smart Search.
 *
 * Arm A (Rebuy): this file does nothing.
 * Arm B (ours):  this file is the search. Rebuy's is hidden by CSS, but only
 *                once this file has started cleanly (html.wow-search-ready for
 *                the dropdown, html.wow-search-page-ready for /search).
 *
 * The group comes from snippets/wow-cart-head.liquid (window.WowCartConfig).
 * Source of truth: storefront/wow-search/ in the WOW repo - never edit this in
 * the Shopify theme editor, the next deploy overwrites it.
 */
(function (root) {
  'use strict';

  /* ---------- pure helpers (unit-tested in storefront/wow-search/test) ---------- */

  var MIN_CHARS = 3;          // Rebuy: "Type at least 3 characters to see results"
  var MAX_CLICKS = 20;
  var COLLECTIONS_SHOWN = 5;  // the rest sit behind "See more ..."

  function formatMoney(cents, format) {
    var value = (Number(cents) || 0) / 100;
    var fmt = format || '${{amount}}';
    function withCommas(n, decimals) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return withCommas(Math.round(value), 0);
      return withCommas(value, 2);
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cleanTerm(s) {
    return String(s == null ? '' : s).replace(/\s+/g, ' ').replace(/^ | $/g, '');
  }

  function shouldSearch(term) {
    return cleanTerm(term).length >= MIN_CHARS;
  }

  function joinPath(base, path) {
    return String(base || '/').replace(/\/+$/, '') + '/' + String(path).replace(/^\/+/, '');
  }

  function suggestUrl(base, term) {
    return joinPath(base, 'search/suggest') + '?q=' + encodeURIComponent(cleanTerm(term)) +
      '&resources[type]=product,collection,query&resources[limit]=10&resources[limit_scope]=each' +
      '&section_id=wow-search-suggest';
  }

  function searchPageUrl(base, term) {
    return joinPath(base, 'search') + '?q=' + encodeURIComponent(cleanTerm(term));
  }

  // The JSON a section hands back sits inside a <script data-wow-search-data>.
  function parseSection(html) {
    var m = String(html || '').match(/<script[^>]*data-wow-search-data[^>]*>([\s\S]*?)<\/script>/);
    if (!m) return null;
    try { return withoutGifts(JSON.parse(m[1])); } catch (e) { return null; }
  }

  // The $0 gift products (marketing/scripts/wow_gift_products.py) are handed
  // out by the cart. They are never something to find, or to add, from search.
  function isGiftHandle(handle) {
    return /^free-gift-/.test(String(handle || ''));
  }

  function withoutGifts(data) {
    if (!data) return data;
    ['products', 'handles'].forEach(function (key) {
      if (!Array.isArray(data[key])) return;
      data[key] = data[key].filter(function (p) {
        return !isGiftHandle(p && typeof p === 'object' ? p.handle : p);
      });
    });
    return data;
  }

  // Shopify's search links carry tracking parameters; this store strips them.
  function cleanUrl(url) {
    return String(url || '').replace(/[?#].*$/, '');
  }

  function pickVariant(product, variantId) {
    var variants = (product && product.variants) || [];
    var i;
    if (variantId != null) {
      for (i = 0; i < variants.length; i++) if (String(variants[i].id) === String(variantId)) return variants[i];
    }
    for (i = 0; i < variants.length; i++) if (variants[i].available) return variants[i];
    return variants[0] || null;
  }

  function priceView(variant) {
    var price = Number(variant && variant.price) || 0;
    var compare = Number(variant && variant.compare_at_price) || 0;
    return { price: price, compare: compare, sale: compare > price };
  }

  function showsVariantSelect(product) {
    return !!product && !product.has_only_default_variant && (product.variants || []).length > 1;
  }

  // Suggested searches: what Shopify offers, minus the term already typed.
  function suggestedQueries(queries, term, max) {
    var typed = cleanTerm(term).toLowerCase(), seen = {}, out = [];
    (queries || []).forEach(function (q) {
      var text = cleanTerm(q), key = text.toLowerCase();
      if (!text || key === typed || seen[key] || out.length >= max) return;
      seen[key] = true;
      out.push(text);
    });
    return out;
  }

  function splitCollections(collections, expanded) {
    var all = collections || [];
    if (expanded || all.length <= COLLECTIONS_SHOWN) return { shown: all, more: false };
    return { shown: all.slice(0, COLLECTIONS_SHOWN), more: true };
  }

  // Newest click last, no repeats, never more than MAX_CLICKS.
  function rememberClick(list, handle) {
    var out = (Array.isArray(list) ? list : []).filter(function (h) {
      return typeof h === 'string' && h && h !== handle;
    });
    if (handle) out.push(String(handle));
    return out.slice(-MAX_CLICKS);
  }

  function liveMessage(view, term, count) {
    if (view === 'loading') return 'Searching for ' + term + '…';
    if (view === 'empty') return 'No results found for ' + term;
    if (view === 'results') return count + (count === 1 ? ' result found for ' : ' results found for ') + term;
    return '';
  }

  // Arrow keys walk the dropdown's links and buttons; the ends wrap around.
  function stepIndex(current, count, delta) {
    if (count <= 0) return -1;
    if (current < 0) return delta > 0 ? 0 : count - 1;
    return (current + delta + count) % count;
  }

  function imageUrl(src, width) {
    if (!src) return '';
    var u = String(src).replace(/^https?:/, '');
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function imageSrcset(src) {
    if (!src) return '';
    return [320, 480, 640, 960, 1280].map(function (w) { return imageUrl(src, w) + ' ' + w + 'w'; }).join(', ');
  }

  /* results page (/search) */

  var PAGE_SIZE = 15;         // Rebuy: 15 products a page
  var TYPES_SHOWN = 10;
  var TAGS_SHOWN = 20;
  var SORTS = [
    { value: 'relevance', label: 'Relevance' },
    { value: 'best-sellers', label: 'Best Sellers' },
    { value: 'highest-price', label: 'Highest Price' },
    { value: 'lowest-price', label: 'Lowest Price' },
    { value: 'new-arrivals', label: 'New Arrivals' }
  ];

  function decodePart(s) {
    try { return decodeURIComponent(String(s).replace(/\+/g, ' ')); } catch (e) { return String(s); }
  }

  function encodePart(s) {
    return encodeURIComponent(String(s)).replace(/%20/g, '+');
  }

  function parseQuery(search) {
    var out = {};
    String(search || '').replace(/^\?/, '').split('&').forEach(function (pair) {
      if (!pair) return;
      var i = pair.indexOf('=');
      out[decodePart(i === -1 ? pair : pair.slice(0, i))] = decodePart(i === -1 ? '' : pair.slice(i + 1));
    });
    return out;
  }

  function splitList(s) {
    return String(s || '').split(',').map(cleanTerm).filter(function (v) { return v !== ''; });
  }

  function toPrice(s) {
    if (s == null || String(s).replace(/\s/g, '') === '') return null;
    var n = Number(s);
    return isFinite(n) && n >= 0 ? n : null;
  }

  function validSort(value) {
    for (var i = 0; i < SORTS.length; i++) if (SORTS[i].value === value) return value;
    return SORTS[0].value;
  }

  // The address bar speaks Rebuy's dialect (rb_categories, rb_tags, ...), so a
  // link saved from either search opens the same results in the other.
  function readState(search) {
    var q = parseQuery(search);
    return {
      term: cleanTerm(q.q),
      sort: validSort(q.rb_sort_by),
      types: splitList(q.rb_categories),
      tags: splitList(q.rb_tags),
      vendors: splitList(q.rb_vendors),
      inStock: q.rb_availability === 'available',
      priceMin: toPrice(q.rb_price_gte),
      priceMax: toPrice(q.rb_price_lte),
      page: 1
    };
  }

  function writeState(state) {
    var parts = ['q=' + encodePart(state.term || '')];
    if (state.types.length) parts.push('rb_categories=' + encodePart(state.types.join(',')));
    parts.push('rb_sort_by=' + encodePart(state.sort));
    if (state.inStock) parts.push('rb_availability=available');
    if (state.priceMin != null || state.priceMax != null) {
      parts.push('rb_price_gte=' + encodePart(state.priceMin != null ? state.priceMin : '0.00'));
    }
    if (state.priceMax != null) parts.push('rb_price_lte=' + encodePart(state.priceMax));
    if (state.tags.length) parts.push('rb_tags=' + encodePart(state.tags.join(',')));
    if (state.vendors.length) parts.push('rb_vendors=' + encodePart(state.vendors.join(',')));
    return '?' + parts.join('&');
  }

  function hasFilters(state) {
    return !!(state.types.length || state.tags.length || state.vendors.length || state.inStock ||
      state.priceMin != null || state.priceMax != null);
  }

  // "Reset" clears the filters and keeps the term and the sort order.
  function clearFilters(state) {
    return { term: state.term, sort: state.sort, types: [], tags: [], vendors: [], inStock: false,
      priceMin: null, priceMax: null, page: 1 };
  }

  function toggleValue(list, value) {
    var out = (list || []).filter(function (v) { return v !== value; });
    if (out.length === (list || []).length) out.push(value);
    return out;
  }

  function resultsUrl(base, term, page) {
    return joinPath(base, 'search') + '?q=' + encodeURIComponent(cleanTerm(term)) +
      '&type=product&options[prefix]=last' + (page > 1 ? '&page=' + page : '') +
      '&section_id=wow-search-results';
  }

  function rankUrl(base, page) {
    return joinPath(base, 'collections/all') + '?sort_by=best-selling' + (page > 1 ? '&page=' + page : '') +
      '&section_id=wow-search-rank';
  }

  // Shopify's search answers most words with most of the catalogue. The
  // section marks the products that carry the searched words in their own
  // text (what Rebuy goes by); those are the results, unless there are none.
  function narrow(list) {
    var marked = (list || []).filter(function (p) { return p && p.match !== false; });
    return marked.length ? marked : (list || []);
  }

  // Which size of the product answers the filters: the first one in stock that
  // fits the price range, else the first that fits. No fit, no product.
  function matchVariant(product, state) {
    var lo = state.priceMin != null ? Math.round(state.priceMin * 100) : null;
    var hi = state.priceMax != null ? Math.round(state.priceMax * 100) : null;
    var fits = ((product && product.variants) || []).filter(function (v) {
      if (lo != null && v.price < lo) return false;
      if (hi != null && v.price > hi) return false;
      return !(state.inStock && !v.available);
    });
    return pickVariant({ variants: fits });
  }

  function applyFilters(list, state) {
    var out = [];
    (list || []).forEach(function (product, index) {
      if (state.types.length && state.types.indexOf(product.type || '') === -1) return;
      if (state.vendors.length && state.vendors.indexOf(product.vendor || '') === -1) return;
      var tags = product.tags || [];
      if (!state.tags.every(function (t) { return tags.indexOf(t) !== -1; })) return;
      var variant = matchVariant(product, state);
      if (!variant) return;
      out.push({ product: product, variant: variant, index: index });
    });
    return out;
  }

  function countValues(items, read, max) {
    var counts = {}, order = [];
    items.forEach(function (item) {
      [].concat(read(item.product) || []).forEach(function (value) {
        if (value == null || cleanTerm(value) === '') return;
        if (!counts[value]) { counts[value] = 0; order.push(value); }
        counts[value]++;
      });
    });
    var out = order.map(function (value) { return { value: value, count: counts[value] }; });
    out.sort(function (a, b) {
      if (b.count !== a.count) return b.count - a.count;
      return a.value.toLowerCase() < b.value.toLowerCase() ? -1 : 1;
    });
    return max ? out.slice(0, max) : out;
  }

  // The counts beside each filter describe what is on screen now, so picking
  // one filter narrows the others - the way Rebuy's do.
  function facets(items) {
    return {
      inStock: items.filter(function (i) { return i.product.available; }).length,
      types: countValues(items, function (p) { return p.type; }, TYPES_SHOWN),
      tags: countValues(items, function (p) { return p.tags; }, TAGS_SHOWN),
      vendors: countValues(items, function (p) { return p.vendor; }, 0)
    };
  }

  function sortItems(items, sort, rank) {
    var out = items.slice();
    function by(read, direction) {
      out.sort(function (a, b) {
        var x = read(a), y = read(b);
        if (x !== y) return x < y ? -direction : direction;
        return a.index - b.index;
      });
    }
    if (sort === 'highest-price') by(function (i) { return i.variant.price; }, -1);
    else if (sort === 'lowest-price') by(function (i) { return i.variant.price; }, 1);
    else if (sort === 'new-arrivals') by(function (i) { return Number(i.product.created_at) || 0; }, -1);
    else if (sort === 'best-sellers') {
      by(function (i) {
        var at = (rank || []).indexOf(i.product.handle);
        return at === -1 ? Infinity : at;
      }, 1);
    } else by(function (i) { return i.index; }, 1);
    return out;
  }

  function pageCount(total) {
    return Math.max(1, Math.ceil(total / PAGE_SIZE));
  }

  function pageOf(items, page) {
    var p = Math.min(Math.max(1, page || 1), pageCount(items.length));
    return items.slice((p - 1) * PAGE_SIZE, p * PAGE_SIZE);
  }

  // Rebuy picks the column count from the window width when the page loads.
  function columnsFor(width) {
    if (width < 481) return 1;
    if (width < 768) return 2;
    return 4;
  }

  // "upsell-strainer" reads "Upsell Strainer"; "tea accessories" reads "Tea accessories".
  function tagLabel(tag) {
    return String(tag || '').split('-').map(function (part) {
      return part.charAt(0).toUpperCase() + part.slice(1);
    }).join(' ');
  }

  function resultsTitle(term, count) {
    return 'Showing results for "' + term + '" (' + count + ')';
  }

  function emptyMessage(term) {
    return 'No results found for “' + term + '”. Check the spelling or use a different word or phrase.';
  }

  function pageTitle(term, count, shop) {
    return 'Search: ' + count + ' results for "' + term + '" - ' + shop;
  }

  var helpers = {
    MIN_CHARS: MIN_CHARS, MAX_CLICKS: MAX_CLICKS, PAGE_SIZE: PAGE_SIZE, SORTS: SORTS,
    formatMoney: formatMoney, escapeHtml: escapeHtml, cleanTerm: cleanTerm, shouldSearch: shouldSearch,
    suggestUrl: suggestUrl, searchPageUrl: searchPageUrl, parseSection: parseSection, cleanUrl: cleanUrl,
    pickVariant: pickVariant, priceView: priceView, showsVariantSelect: showsVariantSelect,
    suggestedQueries: suggestedQueries, splitCollections: splitCollections, rememberClick: rememberClick,
    liveMessage: liveMessage, stepIndex: stepIndex, imageUrl: imageUrl, imageSrcset: imageSrcset,
    parseQuery: parseQuery, readState: readState, writeState: writeState, hasFilters: hasFilters,
    clearFilters: clearFilters, toggleValue: toggleValue, resultsUrl: resultsUrl, rankUrl: rankUrl,
    narrow: narrow, matchVariant: matchVariant, applyFilters: applyFilters, facets: facets, sortItems: sortItems,
    pageCount: pageCount, pageOf: pageOf, columnsFor: columnsFor, tagLabel: tagLabel,
    resultsTitle: resultsTitle, emptyMessage: emptyMessage, pageTitle: pageTitle
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = helpers; return; }

  /* ---------- browser only from here ---------- */

  var CART = root.WowCartConfig;
  var CFG = root.WowSearchConfig;
  if (!CART || !CFG || CART.arm !== 'B') return;
  var doc = root.document;
  var BASE = (CART.routes && CART.routes.root) || '/';
  var CLICKS_KEY = 'wow_search_clicks';
  // What opens Rebuy's dropdown today (Rebuy.SmartSearch.quickView.triggerSelector).
  var TRIGGERS = '.header__icon.header__icon--search, a[href="/search"], input[name="q"], form[action="/search"], search-button > button';
  // Where Rebuy puts it: first of these on the page, as its first child.
  var MOUNTS = 'header, #shopify-section-header, sticky-header, theme-header';

  function money(c) { return formatMoney(c, CART.moneyFormat); }

  // Search reads go through XMLHttpRequest so a stale one can be cancelled.
  function getSection(url, onDone) {
    var xhr = new root.XMLHttpRequest();
    xhr.open('GET', url);
    xhr.onload = function () {
      var data = xhr.status >= 200 && xhr.status < 300 ? parseSection(xhr.responseText) : null;
      onDone(data);
    };
    xhr.onerror = function () { onDone(null); };
    xhr.send(null);
    return xhr;
  }

  // XMLHttpRequest on purpose, not fetch: see "Things that will bite you" in
  // storefront/wow-cart/README.md (the shipping-protection app).
  function addToCart(variantId) {
    return new Promise(function (resolve, reject) {
      var xhr = new root.XMLHttpRequest();
      xhr.open('POST', joinPath(BASE, 'cart/add.js'));
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) resolve(); else reject(new Error('cart ' + xhr.status));
      };
      xhr.onerror = function () { reject(new Error('network')); };
      xhr.send(JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { _wow_src: 'search' } }] }));
    });
  }

  // A later step reads this list to credit search with the sale when the
  // shopper clicks through to the product instead of adding from here.
  function noteClick(handle) {
    if (!handle) return;
    try {
      var list = JSON.parse(root.sessionStorage.getItem(CLICKS_KEY) || '[]');
      root.sessionStorage.setItem(CLICKS_KEY, JSON.stringify(rememberClick(list, handle)));
    } catch (e) { /* storage blocked: nothing to remember */ }
  }

  var ICON = {
    closeMenu: '<svg width="11" height="18" viewBox="0 0 13 20" aria-hidden="true"><path d="M1 4.5l11 11M12 4.5l-11 11" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>',
    closeSmall: '<svg width="8" height="15" viewBox="0 0 13 20" aria-hidden="true"><path d="M1 4.5l11 11M12 4.5l-11 11" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
    chevronDown: '<svg class="wow-search__icon" width="14" height="16" viewBox="0 0 14 16" aria-hidden="true"><path d="M2 6l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    chevronUp: '<svg class="wow-search__icon" width="14" height="16" viewBox="0 0 14 16" aria-hidden="true"><path d="M2 10l5-5 5 5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    plus: '<svg class="wow-search__icon" width="12" height="16" viewBox="0 0 12 16" aria-hidden="true"><path d="M1 8h10M6 3v10" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
    minus: '<svg class="wow-search__icon" width="12" height="16" viewBox="0 0 12 16" aria-hidden="true"><path d="M1 8h10" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
    prev: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M15.7 7.4L14.3 6l-6 6 6 6 1.4-1.4L11.1 12z"/></svg>',
    next: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M9.7 6L8.3 7.4l4.6 4.6-4.6 4.6L9.7 18l6-6z"/></svg>'
  };

  /* ---------- product cards (dropdown and results page) ---------- */

  var products = {};   // handle -> product, for whatever is on screen

  function priceHtml(variant) {
    var v = priceView(variant);
    if (v.sale) {
      return '<span class="wow-search__money wow-search__money--sale"><span class="wow-search__sr">Sale price</span> <span>' + money(v.price) + '</span></span> ' +
        '<span class="wow-search__money wow-search__money--compare"><span class="wow-search__sr">Original price</span> <span>' + money(v.compare) + '</span></span>';
    }
    return '<span class="wow-search__money"><span class="wow-search__sr">Price</span> <span>' + money(v.price) + '</span></span>';
  }

  function imageHtml(product, variant, alt, sizes) {
    var src = (variant && variant.image) || product.image;
    if (!src) return '';
    return '<img class="wow-search__image" src="' + escapeHtml(imageUrl(src, 640)) + '" srcset="' + escapeHtml(imageSrcset(src)) +
      '" sizes="' + sizes + '" alt="' + escapeHtml(alt) + '" loading="lazy">';
  }

  function buttonLabel(variant) {
    return variant && variant.available ? CFG.text.add : CFG.text.soldOut;
  }

  function productCard(product, opts) {
    var variant = pickVariant(product);
    var alt = opts.recommended ? product.title : 'Image of ' + product.title;
    products[product.handle] = product;
    var select = showsVariantSelect(product)
      ? '<div class="wow-search__product-options"><select class="wow-search__select" title="Select product variant" ' +
          'aria-label="variant of ' + escapeHtml(product.title) + '" data-wow-variant>' +
          product.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v === variant ? ' selected' : '') + '>' + escapeHtml(v.title) + '</option>';
          }).join('') +
        '</select></div>'
      : '';
    return '' +
      '<div class="wow-search__product" data-handle="' + escapeHtml(product.handle) + '">' +
        '<a href="' + escapeHtml(product.url) + '" rel="nofollow" class="wow-search__image-link" data-wow-product-link>' +
          imageHtml(product, variant, alt, '(min-width: 768px) 480px, 50vw') +
        '</a>' +
        '<div class="wow-search__product-detail">' +
          '<div class="wow-search__product-info">' +
            '<a href="' + escapeHtml(product.url) + '" rel="nofollow" class="wow-search__product-title" data-wow-product-link> ' +
              escapeHtml(product.title) + ' </a>' +
            '<div class="wow-search__price" data-wow-price>' + priceHtml(variant) + '</div>' +
          '</div>' +
          select +
          '<div class="wow-search__product-actions">' +
            '<button type="button" class="wow-search__button" data-wow-add' + (variant && variant.available ? '' : ' disabled') +
              ' aria-label="Add the product, ' + escapeHtml(product.title) + ' to Cart"><span>' + buttonLabel(variant) + '</span></button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function cardOf(node) {
    var card = node.closest('[data-handle]');
    return card ? { node: card, product: products[card.getAttribute('data-handle')] } : null;
  }

  function onVariantChange(select) {
    var card = cardOf(select);
    if (!card || !card.product) return;
    var variant = pickVariant(card.product, select.value);
    var button = card.node.querySelector('[data-wow-add]');
    var img = card.node.querySelector('.wow-search__image');
    card.node.querySelector('[data-wow-price]').innerHTML = priceHtml(variant);
    button.disabled = !variant.available;
    button.firstChild.textContent = buttonLabel(variant);
    if (img && (variant.image || card.product.image)) {
      img.src = imageUrl(variant.image || card.product.image, 640);
      img.srcset = imageSrcset(variant.image || card.product.image);
    }
  }

  function onAdd(button) {
    var card = cardOf(button);
    if (!card || !card.product || button.disabled) return;
    var select = card.node.querySelector('[data-wow-variant]');
    var variant = pickVariant(card.product, select ? select.value : null);
    var label = button.firstChild;
    button.disabled = true;
    label.textContent = CFG.text.adding;
    addToCart(variant.id).then(function () {
      label.textContent = CFG.text.added;
      // The cart (ours, in this group) sees the add and slides out on its own.
      root.setTimeout(function () { label.textContent = buttonLabel(variant); button.disabled = !variant.available; }, 1200);
    }).catch(function () {
      label.textContent = buttonLabel(variant);
      button.disabled = !variant.available;
    });
  }

  function bindCards(el) {
    el.addEventListener('change', function (ev) {
      var select = ev.target.closest && ev.target.closest('[data-wow-variant]');
      if (select) onVariantChange(select);
    });
    el.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t.closest) return;
      var add = t.closest('[data-wow-add]');
      if (add) { onAdd(add); return; }
      var link = t.closest('[data-wow-product-link]');
      if (link) { var card = cardOf(link); if (card) noteClick(card.node.getAttribute('data-handle')); }
    });
  }

  /* ---------- the dropdown ---------- */

  var el, refs = {};
  var state = { view: 'suggest', term: '', data: null, expanded: false };
  var home = null;            // suggested terms + recommended products
  var pending = null, timer = null, run = 0;
  var lastFocus = null;

  function termItems() {
    return ((home && home.terms) || []).map(function (t) {
      return '<li role="button" tabindex="0" aria-label="Suggested Search Term: ' + escapeHtml(t) +
        '" class="wow-search__term" data-wow-term="' + escapeHtml(t) + '"> ' + escapeHtml(t) + ' </li>';
    }).join('');
  }

  function suggestHtml() {
    var recs = (home && home.products) || [];
    var terms = (home && home.terms) || [];
    return '' +
      '<div class="wow-search__suggestions">' +
        '<div class="wow-search__left">' +
          (terms.length
            ? '<div class="wow-search__term-section"><p class="wow-search__title">' + CFG.text.suggestedTerms + '</p>' +
              '<ul class="wow-search__term-list">' + termItems(true) + '</ul></div>'
            : '') +
        '</div>' +
        '<div class="wow-search__right">' +
          (terms.length
            ? '<div class="wow-search__term-section wow-search__term-section--mobile"><p class="wow-search__title"> ' + CFG.text.suggestedTerms + ' </p>' +
              '<ul class="wow-search__term-list wow-search__term-list--mobile">' + termItems(false) + '</ul></div>'
            : '') +
          (recs.length
            ? '<div class="wow-search__product-section"><p class="wow-search__title"> ' + CFG.text.recommended + ' </p>' +
              '<div class="wow-search__product-list wow-search__product-list--scroll">' +
                recs.map(function (p) { return productCard(p, { recommended: true }); }).join('') +
              '</div></div>'
            : '') +
        '</div>' +
      '</div>';
  }

  function loadingHtml() {
    return '' +
      '<div class="wow-search__results">' +
        '<div class="wow-search__collection-section"><p class="wow-search__title">' + CFG.text.collections + '</p>' +
          '<div class="wow-search__collection-list"><div class="wow-search__skeleton wow-search__skeleton--line"></div></div></div>' +
        '<div class="wow-search__product-section"><p class="wow-search__title">' + CFG.text.products + '</p>' +
          '<div class="wow-search__product-list">' +
            '<div class="wow-search__product wow-search__product--skeleton">' +
              '<div class="wow-search__skeleton wow-search__skeleton--image"></div>' +
              '<div class="wow-search__skeleton wow-search__skeleton--name"></div>' +
              '<div class="wow-search__skeleton wow-search__skeleton--price"></div>' +
            '</div>' +
          '</div></div>' +
      '</div>';
  }

  function emptyHtml() {
    return '<div class="wow-search__results"><div class="wow-search__no-results"><p>' + CFG.text.noResults +
      ' [<span>' + escapeHtml(state.term) + '</span>]</p></div></div>';
  }

  function resultsHtml() {
    var data = state.data;
    var queries = suggestedQueries(data.queries, state.term, 3);
    var cols = splitCollections(data.collections, state.expanded);
    return '' +
      '<div class="wow-search__results">' +
        (queries.length
          ? '<div class="wow-search__keywords-section"><p class="wow-search__keyword-title">' + CFG.text.suggestedSearches + '</p>' +
            '<div class="wow-search__keyword-list">' + queries.map(function (q) {
              return '<p class="wow-search__keyword" role="button" tabindex="0" data-wow-term="' + escapeHtml(q) + '"> ' + escapeHtml(q) + ' </p>';
            }).join('') + '</div></div>'
          : '') +
        (cols.shown.length
          ? '<div class="wow-search__collection-section"><p class="wow-search__title">' + CFG.text.collections + '</p>' +
            '<div class="wow-search__collection-list">' + cols.shown.map(function (c) {
              return '<a href="' + escapeHtml(cleanUrl(c.url)) + '" class="wow-search__collection"> ' + escapeHtml(c.title) + ' </a>';
            }).join('') +
            (cols.more ? ' <button type="button" class="wow-search__see-more" data-wow-more> ' + CFG.text.seeMore + ' </button>' : '') +
            '</div></div>'
          : '') +
        (data.products.length
          ? '<div class="wow-search__product-section"><p class="wow-search__title">' + CFG.text.products + '</p>' +
            '<div class="wow-search__product-list">' +
              data.products.map(function (p) { return productCard(p, {}); }).join('') +
            '</div></div>'
          : '') +
      '</div>';
  }

  function render() {
    var html;
    if (state.view === 'loading') html = loadingHtml();
    else if (state.view === 'empty') html = emptyHtml();
    else if (state.view === 'results') html = resultsHtml();
    else html = suggestHtml();
    refs.body.innerHTML = html;
    refs.live.textContent = liveMessage(state.view, state.term,
      state.data && state.data.products ? state.data.products.length : 0);
  }

  function show(view, data) {
    state.view = view;
    state.data = data || null;
    render();
  }

  function search(term) {
    var mine = ++run;
    root.clearTimeout(timer);
    if (pending) { pending.abort(); pending = null; }
    state.term = cleanTerm(term);
    state.expanded = false;
    if (!shouldSearch(term)) { show('suggest'); return; }
    show('loading');
    timer = root.setTimeout(function () {
      pending = getSection(suggestUrl(BASE, state.term), function (data) {
        if (mine !== run) return;
        pending = null;
        // A failed lookup falls back to the opening view rather than claiming
        // there is nothing to find.
        if (!data || !data.performed) { show('suggest'); return; }
        var hits = data.products.length + data.collections.length;
        show(hits ? 'results' : 'empty', data);
      });
    }, CFG.debounceMs);
  }

  function loadHome() {
    if (home) return;
    home = { terms: [], products: [] };
    getSection(joinPath(BASE, '') + '?section_id=wow-search-suggest', function (data) {
      if (!data) return;
      home = data;
      if (state.view === 'suggest') render();
    });
  }

  function isOpen() { return refs.container.classList.contains('is-visible'); }

  // The header is always in view, so the page never needs to move for this.
  function focusInput() {
    try { refs.input.focus({ preventScroll: true }); } catch (e) { refs.input.focus(); }
  }

  function fitOverlay() {
    var box = refs.container.parentNode.getBoundingClientRect();
    refs.overlay.style.maxHeight = Math.max(200, Math.round(root.innerHeight - box.bottom)) + 'px';
  }

  function open(trigger) {
    if (isOpen()) { focusInput(); return; }
    lastFocus = trigger || doc.activeElement;
    refs.container.classList.add('is-visible');
    fitOverlay();
    // After the theme has finished with the same click (it opens its own,
    // empty, search popup and moves the focus).
    root.setTimeout(function () { if (isOpen()) focusInput(); }, 60);
  }

  function close() {
    if (!isOpen()) return;
    var inside = el.contains(doc.activeElement);
    refs.container.classList.remove('is-visible');
    if (inside && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function focusables() {
    // The picture and the name of a product lead to the same place; stop once.
    var list = refs.body.querySelectorAll('[data-wow-term], a[href]:not(.wow-search__image-link), button:not([disabled]), select');
    return Array.prototype.filter.call(list, function (n) { return n.offsetParent !== null; });
  }

  function onKeydown(ev) {
    var t = ev.target;
    if (ev.key === 'Enter' && t === refs.input) {
      ev.preventDefault();
      if (cleanTerm(refs.input.value)) root.location.href = searchPageUrl(BASE, refs.input.value);
      return;
    }
    if ((ev.key === 'Enter' || ev.key === ' ') && t.hasAttribute && t.hasAttribute('data-wow-term')) {
      ev.preventDefault();
      useTerm(t.getAttribute('data-wow-term'));
      return;
    }
    if (ev.key !== 'ArrowDown' && ev.key !== 'ArrowUp') return;
    if (t.tagName === 'SELECT') return;   // the arrows belong to the size picker
    var items = focusables();
    var at = items.indexOf(t);
    if (ev.key === 'ArrowUp' && at <= 0) { ev.preventDefault(); focusInput(); return; }
    var next = stepIndex(at, items.length, ev.key === 'ArrowDown' ? 1 : -1);
    if (next === -1) return;
    ev.preventDefault();
    items[next].focus();
  }

  function useTerm(term) {
    refs.input.value = term;
    search(term);
    focusInput();
  }

  function bind() {
    refs.input.addEventListener('input', function () { search(refs.input.value); });
    el.addEventListener('keydown', onKeydown);
    el.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t.closest) return;
      if (t.closest('[data-wow-close]')) { close(); return; }
      var term = t.closest('[data-wow-term]');
      if (term) { useTerm(term.getAttribute('data-wow-term')); return; }
      if (t.closest('[data-wow-more]')) { state.expanded = true; render(); }
    });
    bindCards(el);

    // Window-capture: runs before the theme's and Rebuy's own handlers, and
    // stops neither. The theme still flips its search icon and locks the page
    // scroll, exactly as it does behind Rebuy's dropdown.
    root.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest || !root.WowSearch || !root.WowSearch.ready) return;
      if (el.contains(t)) return;
      var trigger = t.closest(TRIGGERS);
      if (trigger) {
        if (trigger.tagName === 'A') ev.preventDefault();
        open(trigger);
        return;
      }
      close();
    }, true);
    doc.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') close(); });
    root.addEventListener('resize', function () { if (isOpen()) fitOverlay(); });
  }

  function startDropdown() {
    el = doc.getElementById('wow-search');
    var mount = doc.querySelector(MOUNTS);
    if (!el || !mount) return false;
    refs = {
      container: el.querySelector('.wow-search__container'),
      input: el.querySelector('[data-wow-input]'),
      live: el.querySelector('[data-wow-live]'),
      overlay: el.querySelector('.wow-search__overlay'),
      body: el.querySelector('[data-wow-body]')
    };
    mount.insertBefore(el, mount.firstChild);
    el.hidden = false;
    bind();
    render();
    root.WowSearch = { ready: true, open: open, close: close, search: useTerm };
    doc.documentElement.classList.add('wow-search-ready');
    // Fetch the opening view once the page has settled, so it is there before
    // the first click on the search icon.
    if (doc.readyState === 'complete') loadHome();
    else root.addEventListener('load', loadHome);
    return true;
  }

  /* ---------- the /search page ---------- */

  var page = {
    el: null, refs: {}, state: null,
    products: [],       // everything Shopify found for the term
    cache: {},          // term -> products, so going back is instant
    rank: null,         // best-seller order, fetched on first use
    menuOpen: false, openGroups: {}, columns: 4,
    run: 0, timer: null, failed: false, title: ''
  };
  var GROUPS = [
    { key: 'availability', title: 'Availability' },
    { key: 'type', title: 'Product Type' },
    { key: 'price', title: 'Price' },
    { key: 'tags', title: 'Product Tags' },
    { key: 'vendor', title: 'Vendor' }
  ];

  function loadProducts(term, done) {
    if (!term) { done([]); return; }
    if (page.cache[term]) { done(page.cache[term]); return; }
    var list = [];
    (function next(n) {
      getSection(resultsUrl(BASE, term, n), function (data) {
        if (!data || !data.products) { done(null); return; }
        list = list.concat(data.products);
        // Six pages of fifty is three times the catalogue; a guard, not a limit.
        if (n < data.pages && n < 6) { next(n + 1); return; }
        page.cache[term] = narrow(list);
        done(page.cache[term]);
      });
    })(1);
  }

  function loadRank(done) {
    if (page.rank) { done(); return; }
    var list = [];
    (function next(n) {
      getSection(rankUrl(BASE, n), function (data) {
        if (data && data.handles) list = list.concat(data.handles);
        if (data && n < data.pages && n < 4) { next(n + 1); return; }
        page.rank = list;
        done();
      });
    })(1);
  }

  function checkbox(id, kind, value, label, count, checked) {
    return '<li class="wow-search-page__option">' +
      '<input id="' + escapeHtml(id) + '" type="checkbox" class="wow-search-page__checkbox" data-wow-filter="' + kind +
        '" value="' + escapeHtml(value) + '"' + (checked ? ' checked' : '') + '> ' +
      '<label for="' + escapeHtml(id) + '" class="wow-search-page__option-label"> ' + escapeHtml(label) +
        ' <span class="wow-search-page__option-count"> (' + count + ') </span></label></li>';
  }

  function groupBody(key, f) {
    var s = page.state;
    if (key === 'availability') {
      return '<ul class="wow-search-page__options">' +
        checkbox('wow-search-availability-in-stock', 'stock', 'true', 'In Stock Only', f.inStock, s.inStock) + '</ul>';
    }
    if (key === 'price') {
      return '<div class="wow-search-page__options wow-search-page__range">' +
        '<div class="wow-search-page__price-block"><label for="wow-search-price-from" class="wow-search-page__price-label">$</label> ' +
          '<input id="wow-search-price-from" type="number" placeholder="From" min="0" class="wow-search-page__price-input" data-wow-price="priceMin" value="' +
          (s.priceMin != null ? s.priceMin : '') + '"></div>' +
        ' <div class="wow-search-page__price-dash">-</div> ' +
        '<div class="wow-search-page__price-block"><label for="wow-search-price-to" class="wow-search-page__price-label">$</label> ' +
          '<input id="wow-search-price-to" type="number" placeholder="To" min="0.00" class="wow-search-page__price-input" data-wow-price="priceMax" value="' +
          (s.priceMax != null ? s.priceMax : '') + '"></div>' +
      '</div>';
    }
    var kind = key === 'type' ? 'types' : key === 'tags' ? 'tags' : 'vendors';
    var rows = key === 'type' ? f.types : key === 'tags' ? f.tags : f.vendors;
    return '<ul class="wow-search-page__options">' + rows.map(function (row) {
      return checkbox('wow-search-' + key + '-' + row.value, kind, row.value,
        key === 'tags' ? tagLabel(row.value) : row.value, row.count, s[kind].indexOf(row.value) !== -1);
    }).join('') + '</ul>';
  }

  function chip(label, aria, kind, value) {
    return '<div class="wow-search-page__chip"><span class="wow-search-page__chip-label">' + label + '</span> ' +
      '<button type="button" aria-label="' + escapeHtml(aria) + '" class="wow-search-page__chip-remove" data-wow-remove="' + kind +
      '" value="' + escapeHtml(value) + '">' + ICON.closeSmall + '</button></div>';
  }

  function chipsHtml() {
    var s = page.state, out = '';
    if (s.priceMin != null || s.priceMax != null) {
      var lo = s.priceMin != null ? s.priceMin : '0.00';
      out += chip('<span><span>$</span> <span>' + escapeHtml(lo) + '</span></span> <span>-</span> <span><span>$</span> <span>' +
        escapeHtml(s.priceMax != null ? s.priceMax : lo + ' +') + '</span></span>', 'Remove price filter', 'price', '');
    }
    if (s.inStock) out += chip('In Stock', 'Remove In Stock', 'stock', '');
    s.types.forEach(function (v) { out += chip(escapeHtml(v), 'Remove ' + v + ' product type filter', 'types', v); });
    s.tags.forEach(function (v) { out += chip(escapeHtml(v), 'Remove ' + v + ' tag filter', 'tags', v); });
    s.vendors.forEach(function (v) { out += chip(escapeHtml(v), 'Remove ' + v + ' vendor filter', 'vendors', v); });
    return '<div class="wow-search-page__selected">' +
      '<div class="wow-search-page__selected-header"><h4 class="wow-search-page__group-title"> Selected Filter </h4> ' +
        '<button type="button" class="wow-search-page__reset" data-wow-reset> Reset </button></div>' +
      '<div class="wow-search-page__selected-body">' + out + '</div></div>';
  }

  function menuHtml(f) {
    return '<div id="wow-search-filter-menu" class="wow-search-page__menu">' +
      '<button type="button" aria-label="Close Dropdown" class="wow-search-page__menu-close" data-wow-menu-close>' + ICON.closeMenu + '</button> ' +
      (hasFilters(page.state) ? chipsHtml() : '') +
      '<ul class="wow-search-page__groups">' + GROUPS.map(function (g) {
        var isOpen = !!page.openGroups[g.key];
        return '<li class="wow-search-page__group"><div>' +
          '<div class="wow-search-page__group-header"><button type="button" aria-label="' + (isOpen ? 'Close ' : 'Open ') + g.title +
            '" aria-expanded="' + isOpen + '" class="wow-search-page__group-toggle" data-wow-group="' + g.key + '">' +
            '<h4 class="wow-search-page__group-title">' + g.title + '</h4> <div>' + (isOpen ? ICON.minus : ICON.plus) + '</div></button></div>' +
          (isOpen ? '<div>' + groupBody(g.key, f) + '</div>' : '') +
        '</div></li>';
      }).join('') + '</ul></div>';
  }

  function filtersHtml(f) {
    return '<div><h3 class="wow-search-page__filters-title"> Filters </h3> ' +
        '<div class="wow-search-page__filter">' +
          '<button type="button" aria-label="Open product filters dropdown" aria-expanded="' + page.menuOpen +
            '" class="wow-search-page__filter-button" data-wow-menu><p> Product Filters ' +
            (page.menuOpen ? ICON.chevronUp : ICON.chevronDown) + '</p></button> ' +
          (page.menuOpen ? menuHtml(f) : '') +
        '</div></div> ' +
      '<div><div class="wow-search-page__sort">' +
        '<label for="wow-search-sort" class="wow-search-page__sort-label">Sort By</label> ' +
        '<select id="wow-search-sort" class="wow-search-page__select" data-wow-sort>' + SORTS.map(function (o) {
          return '<option value="' + o.value + '"' + (o.value === page.state.sort ? ' selected' : '') + '> ' + o.label + ' </option>';
        }).join('') + '</select></div></div>';
  }

  function resultCard(item) {
    var p = item.product;
    products[p.handle] = p;
    return '<div class="wow-search-page__product" data-handle="' + escapeHtml(p.handle) + '">' +
      '<a href="' + escapeHtml(p.url) + '" class="wow-search-page__media" data-wow-product-link>' +
        imageHtml(p, item.variant, 'Image of ' + p.title, '(min-width: 768px) 280px, (min-width: 481px) 50vw, 100vw') +
      '</a>' +
      '<div class="wow-search-page__detail"><div class="wow-search-page__info">' +
        '<a href="' + escapeHtml(p.url) + '" class="wow-search-page__title" data-wow-product-link>' + escapeHtml(p.title) + '</a> ' +
        '<div class="wow-search-page__price"><div>' + priceHtml(item.variant) + '</div></div>' +
      '</div></div></div>';
  }

  function pagerHtml(current, pages) {
    if (pages <= 1) return '';
    var out = '<li class="wow-search-page__pager-item"><button type="button" aria-label="Previous page" class="wow-search-page__pager-page wow-search-page__pager-arrow' +
      (current <= 1 ? ' wow-search-page__pager-arrow--disabled" disabled' : '"') + ' data-wow-page="' + (current - 1) + '">' + ICON.prev + '</button></li> ';
    for (var p = 1; p <= pages; p++) {
      out += '<li class="wow-search-page__pager-item' + (p === current ? ' is-active' : '') + '">' +
        '<button type="button" class="wow-search-page__pager-page" data-wow-page="' + p + '"' +
        (p === current ? ' aria-current="page"' : '') + '><span> ' + p + ' </span></button></li>';
    }
    out += ' <li class="wow-search-page__pager-item"><button type="button" aria-label="Next page" class="wow-search-page__pager-page wow-search-page__pager-arrow' +
      (current >= pages ? ' wow-search-page__pager-arrow--disabled" disabled' : '"') + ' data-wow-page="' + (current + 1) + '">' + ICON.next + '</button></li>';
    return '<div class="wow-search-page__pager-section"><ul class="wow-search-page__pager">' + out + '</ul></div>';
  }

  function renderPage() {
    var s = page.state, r = page.refs;
    var items = sortItems(applyFilters(page.products, s), s.sort, page.rank);
    var pages = pageCount(items.length);
    s.page = Math.min(Math.max(1, s.page), pages);
    r.context.innerHTML = items.length
      ? '<h2 class="wow-search-page__result-title">' + escapeHtml(resultsTitle(s.term, items.length)) + '</h2>' : '';
    r.context.hidden = !items.length;
    // Rebuy drops the filters with the last result. Ours stay when it was a
    // filter that emptied the page, so the shopper can take it back off.
    var showFilters = items.length > 0 || hasFilters(s);
    r.filters.innerHTML = showFilters ? filtersHtml(facets(items)) : '';
    r.filters.hidden = !showFilters;
    r.main.innerHTML = '<div><h3 class="wow-search-page__section-title">Products</h3> ' +
      (items.length
        ? '<div class="wow-search-page__grid wow-search-page__grid--' + page.columns + '">' +
            pageOf(items, s.page).map(resultCard).join('') + '</div>'
        : '<div><p>' + escapeHtml(emptyMessage(s.term)) + '</p> </div>') +
      '</div>' + (items.length ? '<div>' + pagerHtml(s.page, pages) + '</div>' : '');
    page.title = pageTitle(s.term, items.length, CFG.shopName);
    doc.title = page.title;
  }

  // Rebuy, out of sight, still writes its own count into the browser tab.
  function guardTitle() {
    var node = doc.querySelector('title');
    if (!node || !root.MutationObserver) return;
    new root.MutationObserver(function () {
      if (!page.failed && page.title && doc.title !== page.title) doc.title = page.title;
    }).observe(node, { childList: true, characterData: true, subtree: true });
  }

  function setLoading(on) {
    page.refs.loader.hidden = !on;
  }

  // Fetch what the term finds (and the best-seller order, if that is the sort),
  // then draw. A slow answer to an older term is dropped.
  function refreshPage() {
    var mine = ++page.run, s = page.state;
    setLoading(true);
    loadProducts(s.term, function (list) {
      if (mine !== page.run) return;
      if (list === null) { setLoading(false); failPage(); return; }
      function draw() {
        if (mine !== page.run) return;
        page.products = list;
        setLoading(false);
        renderPage();
        showPage();
      }
      if (s.sort === 'best-sellers') loadRank(draw); else draw();
    });
  }

  function showPage() {
    page.el.hidden = false;
    doc.documentElement.classList.add('wow-search-page-ready');
  }

  // Our page cannot be drawn: hand /search back to Rebuy.
  function failPage() {
    page.failed = true;
    page.el.hidden = true;
    doc.documentElement.classList.remove('wow-search-page-ready');
  }

  function commit(change, keepPage) {
    if (page.failed) return;
    change(page.state);
    if (!keepPage) page.state.page = 1;
    try { root.history.pushState(null, '', joinPath(BASE, 'search') + writeState(page.state)); } catch (e) { /* address bar stays as it was */ }
    refreshPage();
  }

  function bindPage() {
    var el = page.el, r = page.refs;
    r.input.addEventListener('input', function () {
      root.clearTimeout(page.timer);
      page.timer = root.setTimeout(function () {
        commit(function (s) { s.term = cleanTerm(r.input.value); });
      }, CFG.pageDebounceMs);
    });
    r.input.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') ev.preventDefault(); });
    el.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t.hasAttribute('data-wow-sort')) { commit(function (s) { s.sort = validSort(t.value); }); return; }
      if (t.hasAttribute('data-wow-price')) {
        commit(function (s) { s[t.getAttribute('data-wow-price')] = toPrice(t.value); });
        return;
      }
      var kind = t.getAttribute('data-wow-filter');
      if (kind === 'stock') commit(function (s) { s.inStock = t.checked; });
      else if (kind) commit(function (s) { s[kind] = toggleValue(s[kind], t.value); });
    });
    el.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t.closest) return;
      if (t.closest('[data-wow-menu]')) { page.menuOpen = !page.menuOpen; renderPage(); return; }
      if (t.closest('[data-wow-menu-close]')) { page.menuOpen = false; renderPage(); return; }
      var group = t.closest('[data-wow-group]');
      if (group) {
        var key = group.getAttribute('data-wow-group');
        page.openGroups[key] = !page.openGroups[key];
        renderPage();
        return;
      }
      if (t.closest('[data-wow-reset]')) { commit(function (s) { var c = clearFilters(s); for (var k in c) s[k] = c[k]; }); return; }
      var remove = t.closest('[data-wow-remove]');
      if (remove) {
        var kind = remove.getAttribute('data-wow-remove'), value = remove.value;
        commit(function (s) {
          if (kind === 'price') { s.priceMin = null; s.priceMax = null; }
          else if (kind === 'stock') s.inStock = false;
          else s[kind] = s[kind].filter(function (v) { return v !== value; });
        });
        return;
      }
      var pager = t.closest('[data-wow-page]');
      if (pager && !pager.disabled) {
        // Rebuy keeps the page number out of the address bar; so do we.
        page.state.page = Number(pager.getAttribute('data-wow-page')) || 1;
        page.menuOpen = false;
        renderPage();
      }
    });
    bindCards(el);
    root.addEventListener('popstate', function () {
      if (page.failed) return;
      page.state = readState(root.location.search);
      r.input.value = page.state.term;
      refreshPage();
    });
  }

  function startPage() {
    var main = doc.querySelector('#MainContent, #main-content, #main');
    page.el = doc.getElementById('wow-search-page');
    if (!main || !page.el) return;
    page.refs = {
      input: page.el.querySelector('[data-wow-page-input]'),
      loader: page.el.querySelector('[data-wow-loader]'),
      context: page.el.querySelector('[data-wow-context]'),
      filters: page.el.querySelector('[data-wow-filters]'),
      main: page.el.querySelector('[data-wow-main]')
    };
    page.state = readState(root.location.search);
    page.columns = columnsFor(root.innerWidth);
    page.refs.input.value = page.state.term;
    main.insertBefore(page.el, main.firstChild);
    bindPage();
    guardTitle();
    // Rebuy's page stays on screen until ours has its first results.
    refreshPage();
  }

  function start() {
    try {
      startDropdown();
    } catch (e) {
      // Anything going wrong here must leave the shopper with Rebuy's search.
      doc.documentElement.classList.remove('wow-search-ready');
      if (root.WowSearch) root.WowSearch.ready = false;
      if (root.console) root.console.error('[wow-search] start failed', e);
    }
    try {
      if (CFG.template === 'search') startPage();
    } catch (e) {
      if (page.el) failPage();
      if (root.console) root.console.error('[wow-search] results page failed', e);
    }
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})(typeof window !== 'undefined' ? window : this);
